<template>
  <TFinderLayout
    connect="true"
    >
    <template #sidebar-community>
      <div class="color-white-04">Community</div>
      <TFlex
        class="cursor-pointer mb-2 mt-2"
        @click.native="$router.push({
            name: 'ConnectCommunitySequences'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCommunitySequences'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>train</v-icon>
        <div class="color-white-09">Sequences</div>
      </TFlex>
      <TFlex
        class="cursor-pointer"
        @click.native="$router.push({
            name: 'ConnectCommunityWorkPackages'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCommunityWorkPackages'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>list</v-icon>
        <div class="color-white-09">Workpackages</div>
      </TFlex>
    </template>
    <template #sidebar-company v-if="hasPermission('Business READ')">
      <div class="color-white-04">Company</div>
      <TFlex
        class="cursor-pointer mt-2"
        @click.native="$router.push({
            name: 'ConnectCompanySequences'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCompanySequences'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>train</v-icon>
        <div class="color-white-09">Sequences</div>
      </TFlex>
      <TFlex
        class="cursor-pointer mt-2"
        @click.native="$router.push({
            name: 'ConnectCompanyWorkPackages'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCompanyWorkPackages'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>list</v-icon>
        <div class="color-white-09">Workpackages</div>
      </TFlex>
      <TFlex
      class="cursor-pointer mt-2"
      @click.native="$router.push({
        name: 'ConnectCompanyProjects'
        })"
        >
        <div
        v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCompanyProjects'"
        style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
        />
        <v-icon class="color-white-09 mr-1" small>business</v-icon>
        <div class="color-white-09">Projects</div>
      </TFlex>
      <TFlex
        class="cursor-pointer mt-2"
        @click.native="$router.push({
            name: 'ConnectCompanyMembers'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCompanyMembers'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>people</v-icon>
        <div class="color-white-09">Members</div>
      </TFlex>
      <TFlex
        class="cursor-pointer mt-2"
        @click.native="$router.push({
            name: 'ConnectCompanyStatistics'
          })"
        >
        <div
          v-if="$route.matched[1] && $route.matched[1].name === 'ConnectCompanyStatistics'"
          style="  margin-left: -10px; height: 24px; width: 2px; position: absolute; background-color: rgba(255,255,255,0.9)"
          />
        <v-icon class="color-white-09 mr-1" small>bar_chart</v-icon>
        <div class="color-white-09">Statistics</div>
      </TFlex>
    </template>
    <template #actionbar>
      <v-btn-toggle
        :value="workbench_variables.items_mini?1:0"
        @change="updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              items_mini: $event === 1?true:false
            }
          })"
        mandatory
        dense
        >
        <v-btn v-if="$route.matched[1] && ['ConnectCommunitySequences', 'ConnectCompanySequences'].includes($route.matched[1].name)"><v-icon>view_list</v-icon></v-btn>
        <v-btn v-else><v-icon>view_module</v-icon></v-btn>
        <v-btn><v-icon>apps</v-icon></v-btn>
      </v-btn-toggle>
      <v-spacer/>
      <TSearchField
        height="30px"
        border_color="rgb(41,41,41)"
        :value="workbench_variables.search"
        @input="updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: $event.target.value
            }
          })"
        @cancel="updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: ''
            }
          })"
        />
    </template>
    <template #content>
      <router-view/>
    </template>
  </TFinderLayout>
</template>
<script>
  import { WorkBenchMixin } from '@/mixins/WorkBench.mixin.js'
  export default {
    props: [],
    mixins: [
      WorkBenchMixin,
    ],
    data: () => ({

    }),
  }
</script>
